import styled from "styled-components";
import Button from "common/button";

export const BannerWrapper = styled.section`
  display: flex;
  flex-direction: column;
  .cancel-container {
    align-items: flex-start;
    .cancel-button {
      margin-right: 18px;
      margin-top: 8px;
      @media only screen and (min-width: 768px) {
        flex-direction: column;
      }
    }
  }
  .participants {
    margin-top: 10px;
    margin-bottom: 15px;
    a {
      position: relative;
      display: flex;
      &:hover {
        span {
          color: #09aaff;
          &:after {
            top: 0;
            left: 0;
            content: "";
            position: absolute;
            width: 40px;
            height: 40px;
            border: 2px #09aaff solid;
            border-radius: 50%;
          }
        }
      }
    }
  }
`;

export const BannerContent = styled.div`
  border-radius: 2px;
  background-color: white;
  min-height: 48px;
  display: flex;
  flex-direction: row;
  margin-top: 8px;
`;

export const BannerTitle = styled.div`
  color: #1070b6;
  font-weight: bold;
  text-align: left;
  transform: scaleY(0.99);
  font-size: 22px;
  flex-grow: 1;
  @media only screen and (max-width: 768px) {
    font-size: 18px;
  }
`;

export const BannerIcon = styled.div`
  min-width: 56px;
  height: auto;
  background-color: #d3e8ff;
  padding: 0px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    color: #1070b6;
    max-width: 20px;
  }
`;

export const BannerTextAndButton = styled.div`
  display: flex;
  padding: 10px;
  justify-content: space-between;
  flex-grow: 1;
`;

export const BookClassButton = styled(Button)`
  width: 100%;
  padding: 0px 24px;
  height: 60px;
  font-size: 20px;
  font-weight: bold;
  display: inline-table;
  justify-content: space-between;
  align-items: center;
`;

export const BannerInstruction = styled.div`
  padding-bottom: 12px;
  font-size: 15px;
  color: white;
  text-align: left;
  line-height: 1.6;
  margin: 8px 0px 4px 0px;
`;

export const JoinCourseButton = styled(Button)`
  width: 100%;
  background-color: #d3e8ff;
  height: 45px;
  font-size: 15px;
  font-weight: bold;
  display: inline-table;
  justify-content: space-between;
  align-items: center;
`;

export const JoinCourseText = styled.div`
  font-size: 14px;
  color: white;
  text-align: center;
  line-height: 1.6;
  margin: 8px 0px 4px 0px;
`;

export const JoinCourseContainer = styled.div`
  margin-bottom: 40px;
`;

export const CancelButton = styled.div`
  font-size: 15px;
`;

export const ImmediateCancelButton = styled.div`
  font-size: 11px;
`;
export const BannerButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;
